export default "__VITE_ASSET__9e2b250d__"